export enum GameSubscriptionEndpoints {
  CREATE = "create",
  JOIN = "join",
  CAST_VOTE = "cast-vote",
  RECONNECT_TO_GAME = "reconnect-to-game",
  CREATE_TIMER = "create-timer",
  ADD_TIME = "add-time",
  CANCEL_TIME = "cancel-timer",
  RESET_TIMER = "reset-timer",
  UPDATE_USER = "update-user",
  REVEAL_VOTES = "reveal-votes",
  UPDATE_TASK = "update-task",
  ADD_TASK = "add-task",
  REMOVE_TASK = "remove-task",
  GET_SYSTEMS = "systems",
  START_NEW_VOTING = "start-new-voting",
  FINISH_GAME = "finish-game",
  CHOOSE_FINAL_RESULT = "choose-final-result",
}
